import {
  Tooltip,
  Discount as DiscountBadge, // @FIXME name in toolkit is not ideal
} from '@travel-frontend/ui-components';
import {memo} from 'react';

import {KeywordTypes} from '@/api/keywordApi';
import {LayoutContainer} from '@/components/LayoutContainer';
import {TooltipMarkdown} from '@/components/TooltipMarkdown';
import {useSeaCampaign} from '@/modules/common/context/SeaCampaign';
import {useDestination} from '@/modules/common/hooks/useDestination';
import {Badge} from '@/modules/hotels/components/SeaSpotlight/components/Badge';
import {Body} from '@/modules/hotels/components/SeaSpotlight/components/Body';
import {Container} from '@/modules/hotels/components/SeaSpotlight/components/Container';
import {Headline} from '@/modules/hotels/components/SeaSpotlight/components/Headline';
import {Subline} from '@/modules/hotels/components/SeaSpotlight/components/Subline';

export const SeaSpotlight: React.FunctionComponent = memo(
  function SeaSpotlight() {
    const seaCampaign = useSeaCampaign();
    const destination = useDestination();

    if (!seaCampaign.active || destination.type === KeywordTypes.hotel) {
      return null;
    }

    return (
      <Container backgroundImageUrl={seaCampaign.config?.teaserImageUrl || ''}>
        <LayoutContainer>
          <Body>
            {seaCampaign.config && seaCampaign.config.discountBadge.value && (
              <Tooltip
                content={
                  <TooltipMarkdown
                    value={seaCampaign.config.discountBadge.description}
                  />
                }
                placement="left"
                interactive
              >
                <Badge>
                  <DiscountBadge
                    value={seaCampaign.config.discountBadge.value}
                    badgeColor={seaCampaign.config.discountBadge.badgeColor}
                    textColor={seaCampaign.config.discountBadge.textColor}
                    rotateRight
                  />
                </Badge>
              </Tooltip>
            )}
            <Headline>
              {[
                seaCampaign.config?.headlinePrefix || '',
                destination.keyword?.keyword || '',
              ]
                .filter(Boolean)
                .join(' ')}
            </Headline>
            <Subline>{seaCampaign.config?.subline || ''}</Subline>
          </Body>
        </LayoutContainer>
      </Container>
    );
  }
);
